import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import DoNotDisturbOnOutlinedIcon from '@mui/icons-material/DoNotDisturbOnOutlined';
import AssignmentTurnedInOutlinedIcon from '@mui/icons-material/AssignmentTurnedInOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined';
import { Money, Subscript, Task } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';
const USER_REGISTERED = 'user-registered';
const USER_DELETED_ACCOUNT = 'user-deleted-account';
const ADMIN_RESPONSE_TICKET = 'admin-response-ticket';
const ADMIN_CLOSE_TICKET = 'admin-close-ticket';
// seller
const SELLER_EXAMINATION_APPROVED = 'seller-examination-approved';
const SELLER_EXAMINATION_DENIED = 'seller-examination-denied';
const SELLER_BUYER_BOUGHT_IMAGE = 'seller-buyer-bought-image';
const SELLER_TAX_FORM_APPROVED = 'seller-tax-form-approved';
const SELLER_TAX_FORM_DENIED = 'seller-tax-form-denied';
const SELLER_PAYOUT_APPROVED = 'seller-payout-approved';
const SELLER_PAYOUT_DENIED = 'seller-payout-denied';
const SELLER_IMAGE_100_VIEWS = 'seller-image-100-views';
const SELLER_IMAGE_500_VIEWS = 'seller-image-500-views';
const SELLER_IMAGE_1000_VIEWS = 'seller-image-1000-views';
const SELLER_IMAGE_50_BOUGHT = 'seller-image-50-bought';
const SELLER_IMAGE_100_BOUGHT = 'seller-image-100-bought';
const SELLER_IMAGE_500_BOUGHT = 'seller-image-500-bought';
const SELLER_STATUS_INOPERABLE = 'seller-status-inoperable';
const SELLER_CHANGE_EMAIL_REQUEST_APPROVED = 'seller-change-email-request-approved';
const SELLER_CHANGE_EMAIL_REQUEST_REJECTED = 'seller-change-email-request-rejected';
const SELLER_CHANGE_NAME_REQUEST_APPROVED = 'seller-change-name-request-approved';
const SELLER_CHANGE_NAME_REQUEST_REJECTED = 'seller-change-name-request-rejected';
const SELLER_CHANGE_COUNTRY_REQUEST_APPROVED = 'seller-change-country-request-approved';
const SELLER_CHANGE_COUNTRY_REQUEST_REJECTED = 'seller-change-country-request-rejected';

// buyer
const BUYER_BOUGHT_SUBSCRIPTION = 'buyer-bought-subscription';
const BUYER_INVOICE_REFUND = 'buyer-invoice-refund';

export const NOTIFICATION_TYPES = {
  USER_REGISTERED,
  USER_DELETED_ACCOUNT,
  ADMIN_RESPONSE_TICKET,
  ADMIN_CLOSE_TICKET,
  SELLER_EXAMINATION_APPROVED,
  SELLER_EXAMINATION_DENIED,
  SELLER_BUYER_BOUGHT_IMAGE,
  SELLER_TAX_FORM_APPROVED,
  SELLER_TAX_FORM_DENIED,
  SELLER_PAYOUT_APPROVED,
  SELLER_PAYOUT_DENIED,
  SELLER_IMAGE_100_VIEWS,
  SELLER_IMAGE_500_VIEWS,
  SELLER_IMAGE_1000_VIEWS,
  SELLER_IMAGE_50_BOUGHT,
  SELLER_IMAGE_100_BOUGHT,
  SELLER_IMAGE_500_BOUGHT,
  SELLER_STATUS_INOPERABLE,
  BUYER_BOUGHT_SUBSCRIPTION,
  BUYER_INVOICE_REFUND,
  SELLER_CHANGE_EMAIL_REQUEST_APPROVED,
  SELLER_CHANGE_EMAIL_REQUEST_REJECTED,
  SELLER_CHANGE_NAME_REQUEST_APPROVED,
  SELLER_CHANGE_NAME_REQUEST_REJECTED,
  SELLER_CHANGE_COUNTRY_REQUEST_APPROVED,
  SELLER_CHANGE_COUNTRY_REQUEST_REJECTED
};

export const notificationsIcons = (type: string) => {
  switch (type) {
    case USER_REGISTERED:
      return <AccountCircleIcon />;
    case SELLER_EXAMINATION_APPROVED:
      return <TaskAltOutlinedIcon />
    case SELLER_EXAMINATION_DENIED:
      return <DoNotDisturbOnOutlinedIcon />
    case SELLER_BUYER_BOUGHT_IMAGE:
      return <DoNotDisturbOnOutlinedIcon />
    case SELLER_TAX_FORM_APPROVED:
      return <AssignmentTurnedInOutlinedIcon />
    case SELLER_TAX_FORM_DENIED:
      return <DoNotDisturbOnOutlinedIcon />
    case SELLER_PAYOUT_APPROVED:
      return <SavingsOutlinedIcon />
    case SELLER_PAYOUT_DENIED:
      return <DoNotDisturbOnOutlinedIcon />
    case SELLER_IMAGE_100_VIEWS:
      return <InsertPhotoOutlinedIcon />
    case SELLER_IMAGE_500_VIEWS:
      return <InsertPhotoOutlinedIcon />
    case SELLER_IMAGE_1000_VIEWS:
      return <InsertPhotoOutlinedIcon />
    case SELLER_IMAGE_50_BOUGHT:
      return <AttachMoneyOutlinedIcon />
    case SELLER_IMAGE_100_BOUGHT:
      return <AttachMoneyOutlinedIcon />
    case SELLER_IMAGE_500_BOUGHT:
      return <AttachMoneyOutlinedIcon />
    case ADMIN_RESPONSE_TICKET:
    case ADMIN_CLOSE_TICKET:
      return <Task />
    case BUYER_INVOICE_REFUND:
      return <Money />
    case BUYER_BOUGHT_SUBSCRIPTION:
      return <Subscript />
    case SELLER_CHANGE_COUNTRY_REQUEST_APPROVED:
    case SELLER_CHANGE_EMAIL_REQUEST_APPROVED:
    case SELLER_CHANGE_NAME_REQUEST_APPROVED:
      return <CheckIcon />
    case SELLER_CHANGE_COUNTRY_REQUEST_REJECTED:
    case SELLER_CHANGE_EMAIL_REQUEST_REJECTED:
    case SELLER_CHANGE_NAME_REQUEST_REJECTED:
      return <CancelIcon />
  }
}